<template>
    <section class="process page__section process_screen vidget_wrap blackBack">
        <div class="process__column process__content_col detectMobVisibility">
            <h2 class="page__h2 process__h2">
                <span class="textHide"><span>{{ $t('approach.title') }}</span></span>
            </h2>
            <div class="process__text textFade">{{ $t('approach.descr') }}</div>
            <div class="btn_holder hidden_holder">
                <router-link :to="{name: ((this.$i18n.locale == this.mainLang)? '' : this.$i18n.locale+'.') + 'process', params: { locale: ((this.$i18n.locale == this.mainLang)? '' : '/' + this.$i18n.locale) }}" class="button">
                    <span class="button__text">{{ $t('buttons.explore') }} →</span>
                </router-link>
            </div>
        </div>
        <div class="btn_holder for_mob process_hidden_btn">
            <router-link :to="{name: ((this.$i18n.locale == this.mainLang)? '' : this.$i18n.locale+'.') + 'process', params: { locale: ((this.$i18n.locale == this.mainLang)? '' : '/' + this.$i18n.locale) }}" class="button">
                <span class="button__text">{{ $t('buttons.explore') }} →</span>
            </router-link>
        </div>
        <div class="process__column process_circle_col detectMobVisibility">
            <div class="process__wrapper">
                <div class="process__circle">
                    <div class="process__earth">
                        <div class="process__list">
                            <div class="process__item process__item_first" v-html="$t('approach.discovery')"></div>
                            <div class="process__item process__item_second" v-html="$t('approach.import')"></div>
                            <div class="process__item process__item_third" v-html="$t('approach.pre_sales')"></div>
                            <div class="process__item process__item_fourth" v-html="$t('approach.distribution')"></div>
                            <div class="process__item process__item_fifth" v-html="$t('approach.marketing')"></div>
                            <div class="process__item process__item_sixth" v-html="$t('approach.after_sales')"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    import params from '../../public/site_config.json'
    import i18n from '../lang/lang'
    
    export default {
        data() {
            return {
                mainLang: params.initial_lang
            }
        },
        mounted() {
            
        }
    }
</script>

<style lang="stylus" scoped>
    .process
        background #222
        color #fff
        overflow hidden
        display flex
        flex-direction column

        @media (min-width 1366px)
            flex-direction row

    .btn_holder
        margin-top 20px
            
    .process__text
        color #808080
        font-size 14px
        margin 20px 0
        
        @media (min-width 1024px)
            max-width 345px
            
        @media (min-width 1600px)
            font-size 16px

    .process__h2
        @media (min-width 1600px)
            max-width 70%
            line-height 120%
        
    .process_hidden_btn
        position relative
        padding-left 15px
        z-index 3
        
        @media (min-width 700px)
            display none

    .process__wrapper
        margin 80px 0 40px
        width 100%
        height 500px
        position relative

        @media (min-width 800px)
            margin-bottom 0

        @media (min-width 1024px)
            height 480px
            margin 0 0 0 102px
            top calc(50% - 240px)

    .process__earth
        width 100%
        height 100%
        background url('../assets/images/svg/earth.svg') center no-repeat
            
    .process__circle
        position absolute
        width 420px
        height 420px
        margin-left 96px
        top calc(50% - 210px)
        -webkit-transition .3s
        -moz-transition .3s
        transition .3s
        
        @media (max-width 799px)
            margin-left 0
            right -220px
        
        &:after
            content ''
            position absolute
            left 0
            top 0
            width 100%
            height 100%
            background url('../assets/images/svg/oval_shape.svg') center no-repeat
            background-size contain
            z-index 1
            -webkit-transition .3s
            -moz-transition .3s
            transition .3s
            -webkit-transition-delay .5s
            -moz-transition-delay .5s
            transition-delay .5s
            
            @media (max-width 799px)
                -webkit-transform rotate(120deg)
                -moz-transform rotate(120deg)
                transform rotate(120deg)

        @media (min-width 800px)
            left 50%
            transform translateX(-50%)
            margin 0

            &:before
                content ''
                position absolute
                left -5%
                top -5%
                width 55%
                height 25%
                background #222
                z-index 2

        @media (min-width 1366px)
            position relative
            left 0
            transform none
            margin-left 150px

    .process__button
        margin-top 32px

    .process__list
        position absolute
        left 0
        top 0
        width 50%
        height 100%
        counter-reset service
        z-index 3

    .process__item
        color #C6C8CC
        position absolute
        white-space nowrap
        -webkit-transition .3s
        -moz-transition .3s
        transition .3s

        &:after
            content ''
            position absolute
            right -28px
            top 50%
            transform translate(0, -50%)
            background #808080
            border-radius 3px
            width 6px
            height 6px

    .process__item_first
        right 156px
        top 35px
        -webkit-transition-delay .7s
        -moz-transition-delay .7s
        transition-delay .7s

        @media (min-width 800px)
            right -80px
            top -37px
            width 160px
            text-align center

            &:after
                bottom -17px
                right 50%
                top auto
                transform translate(50%, 0)
                
        @media (min-width 1600px)
            top -40px

    .process__item_second
        right 208px
        top 95px
        -webkit-transition-delay .9s
        -moz-transition-delay .9s
        transition-delay .9s

        @media (min-width 800px)
            right auto
            left 408px
            top 93px

            &:after
                left -25px
                top 8px
                right auto
                transform translate(50%, 0)

        @media (min-width 1600px)
            right -249px

    .process__item_third
        right 231px
        top 160px
        line-height 120%
        text-align right
        -webkit-transition-delay 1.1s
        -moz-transition-delay 1.1s
        transition-delay 1.1s

        @media (min-width 800px)
            right -245px
            top 315px
            text-align left

            &:after
                left -21px
                top 6px
                right auto
                transform translate(50%, 0)

        @media (min-width 1260px)
            left 400px
            right auto

        @media (min-width 1600px)
            right -252px

    .process__item_fourth
        right 231px
        top 235px
        -webkit-transition-delay 1.3s
        -moz-transition-delay 1.3s
        transition-delay 1.3s

        @media (min-width 800px)
            right -34px
            top 433px

            &:after
                top -16px
                right 50%
                transform translate(50%, 0)

    .process__item_fifth
        right 206px
        top 300px
        line-height 1.2
        text-align right
        -webkit-transition-delay 1.5s
        -moz-transition-delay 1.5s
        transition-delay 1.5s
        
        @media (min-width 1024px)
            text-align left
            line-height auto
        
        & > br
            display block
            
            @media (min-width 1024px)
                display none
        
        @media (min-width 800px)
            right 192px
            top 315px
            
            &:after
                right -24px

    .process__item_sixth
        right 150px
        top 362px
        text-align right
        line-height 120%
        -webkit-transition-delay 1.7s
        -moz-transition-delay 1.7s
        transition-delay 1.7s

        @media (min-width 800px)
            right 202px
            top 93px
            
            &:after
                right -26px
                top 10px

    .process__content_col
        display block
        flex-direction column
        justify-content center
        padding-top: 75px
        
        @media (min-width 700px)
            max-width 40%
        
        @media (min-width 1024px)
            padding-top 0
            display flex
            max-width 100%
            
    .process_screen
        padding-left 20px
        display block
        flex-direction row
        justify-content space-between
        
        @media (min-width 700px)
            padding-left 35px
        
        @media (min-width 1024px)
            display flex
            padding-left 80px
            
        @media (min-width 1600px)
            padding-left 100px
    
    .process_circle_col
        position relative
        right 0
        
        @media (min-width 1024px)
            right 25%
            
        @media (min-width 1366px)
            right 17%
        
    .hidden_holder
        display none
        
        @media (min-width 700px)
            display block
</style>